// C12 대균열 절차 효과음 결정(순수 + 작은 상태). 게임(game/field/rift.ts)의 FieldEv 순서: 판 시작 = RiftEnter(b 0) → GriftEnter(a 단계),
// 수호자 = RiftGuardian(단계 정보 없음 → 이 판이 대균열인지 기억해 둔다), 결과 = GriftResult(a 단계, c 1 시간 안·0 초과, d 이정표 강화석).
// 일반 균열(RiftEnter 뒤 GriftEnter 없음)의 수호자에는 소리를 내지 않는다(기존 보스 등장 소리가 맡는다).
import type { GameEvent } from '../../shared/events';
import { FieldEv } from '../../shared/field/view';
import { Y } from './recipes';
import type { SynthCueList } from './decide';

/** 단계 → 돌파 화음 재생 속도: 25단계마다 반음 위(최대 +4반음, 100단계부터) */
export function griftClearRate(tier: number): number {
  const st = Math.max(0, Math.min(4, Math.floor(Math.max(0, tier) / 25)));
  return Math.pow(2, st / 12);
}
/** 단계 → 입장 굉음 재생 속도: 단계가 오를수록 조금 더 낮고 무겁게(최대 −2반음) */
export function griftEnterRate(tier: number): number {
  const st = Math.max(0, Math.min(2, Math.floor(Math.max(0, tier) / 50)));
  return Math.pow(2, -st / 12);
}

export class GriftSfx {
  /** 지금 판의 대균열 단계(0 = 일반 균열·판 밖) */
  tier = 0;
  decide(e: GameEvent, out: SynthCueList): void {
    switch (e.type) {
      case FieldEv.RiftEnter:
        if (e.b === 0) this.tier = 0; // 판의 첫 층: GriftEnter가 곧 뒤따르면 다시 채운다
        break;
      case FieldEv.GriftEnter:
        this.tier = e.a | 0;
        out.add(Y.griftEnter, 0, griftEnterRate(this.tier));
        break;
      case FieldEv.RiftGuardian:
        if (this.tier > 0) out.add(Y.griftGuardian, 0, 1, e.x, e.z);
        break;
      case FieldEv.GriftResult:
        if (e.c === 1) {
          out.add(Y.griftClear, 0, griftClearRate(e.a));
          if (e.d > 0) out.add(Y.griftMilestone, 0, griftClearRate(e.a));
        } else out.add(Y.griftLate);
        this.tier = 0;
        break;
      default:
        break;
    }
  }
}
